import * as React from "react";
import { applyFocusVisiblePolyfill } from "../shared/focusVisiblePolyfill";
import Context from "./Context";
import "../../scss/index.scss";

/**
 * The PatternLibraryProvider is responsible for:
 * - Keeping locale state in context
 * - Applying focus visible polyfill
 * - Loading the CSS resets and font files (through importing the scss file)
 */
import { jsx as ___EmotionJSX } from "@emotion/core";
var fallbackIfNeeded = function fallbackIfNeeded(languageString) {
  return /^\w{2}-[A-Z]{2}$/.test(languageString) ? languageString : "en-US";
};
export var PatternLibraryProvider = function PatternLibraryProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  React.useEffect(function () {
    return applyFocusVisiblePolyfill();
  }, []);
  return ___EmotionJSX(Context.Provider, {
    value: {
      language: fallbackIfNeeded(locale)
    }
  }, children);
};
export default PatternLibraryProvider;